/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { comingBreadcrumbItems } from 'data/coming';
import ComingFilter from './ComingFilter';
import ComingTable from './ComingTable';

const ComingOut = () => {
  const { t } = useTranslation();

  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [optionSenderId, setOptionSenderId] = useState(null);
  const [optionStatusId, setOptionStatusId] = useState(null);
  const [optionDelivererId, setOptionDelivererId] = useState(null);

  return (
    <div>
      <PageBreadcrumb items={comingBreadcrumbItems} />
      <div>
        <h2 className="mb-5">{t('incoming')}</h2>

        <ComingFilter
          dateFrom={dateFrom}
          dateTo={dateTo}
          setDateFrom={setDateFrom}
          setDateTo={setDateTo}
          setOptionSenderId={setOptionSenderId}
          setOptionStatusId={setOptionStatusId}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
          setOptionDelivererId={setOptionDelivererId}
          optionDelivererId={optionDelivererId}
        />
        <ComingTable
          dateFrom={dateFrom}
          dateTo={dateTo}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
          optionDelivererId={optionDelivererId}
        />
      </div>
    </div>
  );
};

export default ComingOut;
